import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["ibanField", "accountNumberField", "bankCodeField"];

  connect() {
    this.ibanFieldTarget.addEventListener("paste", this.handlePaste.bind(this));
  }

  handlePaste(event) {
    event.preventDefault();
    const paste = (event.clipboardData || window.clipboardData)
      .getData("text")
      .replace(/\s+/g, ""); // Removing whitespaces
    this.ibanFieldTarget.value = paste;

    // Assuming the IBAN format is known and fixed, e.g., SKkk BBBB SSSS SSSS SSSS SSSS
    const accountNumber = paste.slice(14); // Extracting account number
    const bankCode = paste.slice(4, 8); // Extracting bank code

    this.accountNumberFieldTarget.value = accountNumber;
    this.bankCodeFieldTarget.value = bankCode;
  }
}
